import { DXF_ENTITY_TYPE } from '@frontend/api';

/**
 * Display names for DXF types whose tag does not read as a word. Everything
 * else is shown as its tag in lower case — `LINE` reads as "line", the way the
 * legacy viewer shows it.
 */
const ENTITY_TYPE_LABELS: Readonly<Record<string, string>> = {
  [DXF_ENTITY_TYPE.LWPOLYLINE]: 'polyline',
  [DXF_ENTITY_TYPE.POLYLINE]: 'polyline',
};

/** What the details overlay calls a DXF entity type. */
export const entityTypeLabel = (entityType: string): string =>
  ENTITY_TYPE_LABELS[entityType] ?? entityType.toLowerCase();
